import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';


@Component({
  selector: 'app-delete-contract',
  templateUrl: './delete-contract.component.html',
  styleUrls: ['./delete-contract.component.scss']
})
export class DeleteContractComponent implements OnInit {

  @Input() contractData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;

  role: any;

  constructor(private appComp: AppComponent, private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {

    this.role = this.authService.getUserRole();
  }

  deleteContract(){
    this.appComp.loading = true; 
    if(this.contractData.contractInstallments.length > 1){
      let installments = this.contractData.contractInstallments;
      for(let i = 0; i< installments.length; i++){
        this.authService.deleteInstallments(this.contractData.contractInstallments[i].id).then(()=>{
          this.authService.deleteContract(this.contractData.id).then(()=>{}, ()=>{})
        })
      }
    } else{
      this.authService.deleteContract(this.contractData.id).then(()=>{}, ()=>{})
    }
    this.appComp.loading = false;
    this.closeBtn.nativeElement.click();
    this.router.navigateByUrl('/contracts');
  }

}
